import Swiper from "swiper";
import { find } from "utils/dom";

export default function () {
	const Page = find("[js-page='clientes']");
	if (!Page) return;


	const swiperClientes = new Swiper('.swiper-clientes', {
		slidesPerView: 'auto',
		centeredSlides: false,
		speed:1000,
		spaceBetween: 24,
		navigation: {
			nextEl: '.customers-container .client-button-next',
			prevEl: '.customers-container .client-button-prev',
		},
		pagination: { 
			el: '.customers-container .swiper-pagination-testimonial',
			type: 'fraction',
		}
	});



	new Swiper(".swiper-clientes-page", {
		slidesPerView: 1,
		spaceBetween: 20,
	
		pagination: {
			type: 'fraction',
				el: ".swiper-clientes-wrapper  .swiper-pagination-testimonial",
				clickable: true,
		},
		navigation: {
				nextEl: ".swiper-clientes-wrapper .client-button-next",
				prevEl: ".swiper-clientes-wrapper .client-button-prev",
		},
		breakpoints: {
				640: { // Mobile
						slidesPerView: 1, // 6 itens por slide
				},
				1024: { // Desktop
						slidesPerView: 2, // 12 itens por slide
				}
		}
});

}
